import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { GraduationCap, Menu, X } from "lucide-react";

const LINKS = [
  ["#accueil", "Accueil"],
  ["#fonctionnalites", "Fonctionnalités"],
  ["#comment", "Comment ça marche"],
  ["#apropos", "À propos"],
  ["#contact", "Contact"],
];

export function Logo({ light }) {
  return (
    <Link to="/" className="flex items-center gap-2" data-testid="landing-logo">
      <div className={`w-9 h-9 rounded-lg grid place-items-center ${light ? "bg-white" : "bg-[#1F7A63]"}`}>
        <GraduationCap className={`w-5 h-5 ${light ? "text-[#1F7A63]" : "text-white"}`} />
      </div>
      <span className={`font-bold text-lg tracking-tight ${light ? "text-white" : ""}`} style={{ fontFamily: "Outfit" }}>EDUKATI</span>
    </Link>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => { document.body.style.overflow = open ? "hidden" : ""; return () => { document.body.style.overflow = ""; }; }, [open]);

  return (
    <>
    <header className={`sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b transition-colors ${scrolled ? "border-[#E2E8F0]" : "border-transparent"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7 text-sm font-medium text-[#1A2E28]">
          {LINKS.map(([href, label]) => (
            <a key={href} href={href} className="hover:text-[#1F7A63] transition-colors" data-testid={`nav-${href.slice(1)}`}>{label}</a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <Link to="/login" data-testid="nav-login-btn"><Button variant="ghost" className="font-semibold">Connexion</Button></Link>
          <Link to="/inscription" data-testid="nav-signup-btn"><Button className="bg-[#1F7A63] hover:bg-[#165c4b] text-white font-semibold px-5">Créer un compte</Button></Link>
        </div>
        <button className="lg:hidden p-2 -mr-2" onClick={() => setOpen(true)} aria-label="Ouvrir le menu" data-testid="nav-mobile-open"><Menu className="w-6 h-6" /></button>
      </div>
    </header>

      {open && (
        <div className="lg:hidden fixed inset-0 z-[60] bg-white flex flex-col" data-testid="nav-mobile-menu">
          <div className="h-16 px-4 flex items-center justify-between border-b border-[#E2E8F0]">
            <Logo />
            <button className="p-2 -mr-2" onClick={() => setOpen(false)} aria-label="Fermer le menu" data-testid="nav-mobile-close"><X className="w-6 h-6" /></button>
          </div>
          <nav className="flex-1 px-4 py-4 flex flex-col">
            {LINKS.map(([href, label]) => (
              <a key={href} href={href} onClick={() => setOpen(false)} className="py-4 text-lg font-semibold border-b border-[#E2E8F0]">{label}</a>
            ))}
          </nav>
          <div className="p-4 grid gap-3 border-t border-[#E2E8F0]">
            <Link to="/login"><Button variant="outline" className="w-full h-12 text-base">Connexion</Button></Link>
            <Link to="/inscription"><Button className="w-full h-12 text-base bg-[#1F7A63] hover:bg-[#165c4b] text-white">Créer un compte</Button></Link>
          </div>
        </div>
      )}
    </>
  );
}
